import { Component, Input } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

interface EndpointResponse {
  Code: string;
  Description: string;
  
  response: {
    success: boolean;
    result: {
      data: any;
      message: string;
    };
  };
}

interface EndpointParameter {
  name: string;
  description: string;
  optional: boolean | 'false';
}

interface Endpoint {
  name: string,
  method: string;
  path: string;
  body?: any;
  request: any,
  responses: EndpointResponse[];
  parameters?: EndpointParameter[] | [];
  custom?: boolean | 'false';
}

interface Endpoints {
  [key: string]: Endpoint;
}

@Component({
  selector: 'app-api-docs',
  templateUrl: './api-docs.component.html',
  styleUrls: ['./api-docs.component.scss']
})
export class ApiDocsComponent {
  @Input() endpoints!: Endpoint[];
  @Input() usecaseCode: any;
  @Input() server: any;
  @Input() api_schema: any;

  testResults: { [key: string]: any } = {};  // Store results
  userInput: { [key: string]: any } = {};  // Store user inputs for each endpoint

  constructor(private http: HttpClient) {
    // Initialize userInput for each endpoint
    this.endpoints && Object.keys(this.endpoints).forEach(key => {
      this.userInput[key] = { parameters: {}, body: '' };
    });
  }

  // Transform string to capital case
  public transform(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  // Method to run API tests based on user input
  runTest(endpoint: Endpoint) {
   // const endpoint = this.endpoints[endpointKey];
    const url = this.server + endpoint.path;
    const userParams = endpoint.parameters || {};
    const userBody = endpoint.body;

    // Prepare query parameters if needed
    let params = new HttpParams();
    // Object.keys(userParams).forEach((paramKey:string) => {
    //   if (userParams[paramKey]) {
    //     params = params.set(paramKey, userParams[paramKey]);
    //   }
    // });

    // Make HTTP request based on method
    if (endpoint.method.toLowerCase() === 'get') {
      // For GET, pass query parameters
      this.http.get(url, { params })
        .subscribe(response => this.testResults[endpoint.name] = response);
    } else if (endpoint.method.toLowerCase() === 'post') {
      // For POST, pass body data
      this.http.post(url, userBody ? JSON.parse(userBody) : {})
        .subscribe(response => this.testResults[endpoint.name] = response);
    }
    // Add logic for other HTTP methods (PUT, DELETE, etc.) as needed
  }

  testMode: boolean[] = []; // Track test mode for each endpoint

  toggleTestMode(index: number) {
    this.testMode[index] = !this.testMode[index];
  }

  createRequestJson(parameters: any[]): object {
    const requestJson:any = {};
    parameters.forEach(param => {
      requestJson[param.name] = param.value; // Assuming each parameter has a value property bound to the input
    });
    return requestJson;
  }
}
